<h1 mat-dialog-title>{{ 'labels.changePassword' | translate }}</h1>
<div mat-dialog-content>
  <form class="form" [formGroup]="form">
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'labels.currentPassword' | translate }}</mat-label>
        <input matInput [type]="hideCurrent ? 'password' : 'text'" maxlength="20" placeholder="{{ 'labels.currentPassword' | translate }}" formControlName="currentPassword" #currentPasswordInput>
        <button mat-icon-button matSuffix (click)="hideCurrent = !hideCurrent" [attr.aria-label]="'Hide current password'" [attr.aria-pressed]="hideCurrent">
          <mat-icon>{{hideCurrent ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="currentPassword?.errors?.['required']">{{ 'errors.required.currentPassword' | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'labels.newPassword' | translate }}</mat-label>
        <input matInput [type]="hideNew ? 'password' : 'text'" maxlength="20" placeholder="{{ 'labels.newPassword' | translate }}" formControlName="password" #passwordInput>
        <button mat-icon-button matSuffix (click)="hideNew = !hideNew" [attr.aria-label]="'Hide new password'" [attr.aria-pressed]="hideNew">
          <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="password?.errors?.['notValid']">{{ 'errors.invalid.passwordFormat' | translate }}</mat-error>
        <mat-error *ngIf="password?.errors?.['required']">{{ 'errors.required.newPassword' | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>{{ 'labels.confirmPassword' | translate }}</mat-label>
        <input matInput [type]="hideConfirm ? 'password' : 'text'" maxlength="20" placeholder="{{ 'labels.confirmPassword' | translate }}" formControlName="confirmPassword" #confirmPasswordInput>
        <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm" [attr.aria-label]="'Hide confirm password'" [attr.aria-pressed]="hideConfirm">
          <mat-icon>{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="confirmPassword?.errors?.['required']">{{ 'errors.required.confirmPassword' | translate }}</mat-error>
        <mat-error *ngIf="confirmPassword?.errors?.['notConfirmed']">{{ 'errors.invalid.confirmPassword' | translate }}</mat-error>
      </mat-form-field>
    </div>
  </form>
</div>
<div class="form-actions" mat-dialog-actions>
  <button mat-stroked-button color="primary" [mat-dialog-close]="" cdkFocusInitial>{{ 'buttons.cancel' | translate }}</button>
  <span class="spacer"></span>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!form.valid">{{ 'buttons.save' | translate }}</button>
</div>